
import state from './menuState.js'
import mutations from './menuMutations.js'
import actions from './menuAction.js'
import getters from './menuGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

